// removed by extract-text-webpack-plugin
module.exports = {"Content":"Layout-module__Content__2YyQq"};


//////////////////
// WEBPACK FOOTER
// ./src/hoc/Layout/Layout.module.css
// module id = 90
// module chunks = 2